import { parseISO, format as formatFNS } from "date-fns"
import storageService from "../services/storage.service";
const ExcelJS = require('exceljs');
import saveAs from "file-saver";

import { ExcelColumnsModel } from '../models/columns.model';
import { truncateSync } from "fs";
import moment from 'moment';
import { dataTableConfig, dataTableConfigLaguages } from "../configs/data-table.config";

const BigNumber = require('bignumber.js');

export const UtilService = {
  getDate,
  replaceAll,
  guid,
  getLower,
  formatDate,
  formatDateTime,
  onlyNumber,
  formatNumber,
  formatNumberIdioma,
  generateExcel,
  compareValues,
  configDate,
  verifyIdiomDataTable,
  toExportDateFormated,
  formatDateAndTime
};

function guid() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    // eslint-disable-next-line no-mixed-operators
    var r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

function generateExcel(sheets, fileName) {

  var ExcelJSWorkbook = new ExcelJS.Workbook();

  for (let i = 0; i < sheets.length; i++) {

    let configColum: ExcelColumnsModel[] = [];

    var worksheet = ExcelJSWorkbook.addWorksheet(sheets[i].Description);

    for (let c = 0; c < sheets[i].Columns.length; c++) {
      let item: ExcelColumnsModel = {
        header: sheets[i].Columns[c],
        key: sheets[i].Columns[c],
        width: 10
      };
      configColum.push(item);
    }

    worksheet.columns = configColum;

    for (let r = 0; r < sheets[i].Rows.length; r++) {
      worksheet.addRow(sheets[i].Rows[r]);
    }
  }

  ExcelJSWorkbook.xlsx.writeBuffer().then(function (buffer) {
    saveAs(
      new Blob([buffer], { type: "application/octet-stream" }),
      fileName
    );
  });

}

function compareValues(inicio, fim) {

  let retorno = false;

  let i = inicio.toString().replaceAll('.', "").replaceAll(',', "")
  let f = fim.toString().replaceAll('.', "").replaceAll(',', "")

  var a = new BigNumber(i);
  var b = new BigNumber(f);

  let result = a.comparedTo(b)

  if (result === 0 || result === -1) {
    retorno = true;
  }
  else {
    retorno = false;
  }

  return retorno;
}

function replaceAll(valor) {
  let string = valor;

  string = string
    .replaceAll("-", "")
    .replaceAll(":", "")
    .replaceAll(".", "")
    .replaceAll('"', "")


  return string
}

function getLower(value) {
  if (typeof value === "string" || value instanceof String)
    return value.toLowerCase()
  else return value
}

function getDate() {
  return new Date().toISOString().slice(0, 10)
}

function isValidDate(date) {
  try {
    return date instanceof Date;
  } catch {
    return false
  }
}

function isValidDateTime(date) {
  try {
    const parsedDate = new Date(date);
    return !isNaN(parsedDate.getTime());  // Verifica se a data é válida
  } catch {
    return false;
  }
}



/* function configDate(value) {
  let _date = new Date();

  try {
    var m = moment(value, 'YYYY-MM-DD');
    if (m.isValid()) {
      _date.setDate(parseInt(moment(value).format("D")))
      _date.setMonth(parseInt(moment(value).format("M")) - 1)
      _date.setFullYear(parseInt(moment(value).format("YYYY")))
      return _date;
    } else {
      return _date;
    }
  }
  catch (e) {
    console.log(e);
    return _date;
  }

}
 */

function configDate(value) {
  try {
    const m = moment(value, 'YYYY-MM-DD');
    if (m.isValid()) {
      // Retorna a data como um objeto `Date`, preservando a data correta
      return m.toDate();
    } else {
      console.log("Data inválida:", value);
      return m.toDate();
    }
  } catch (e) {
    console.log("Erro ao processar a data:", e);
    return null;
  }
}
function formatDate(date, formatDate) {
  let format = formatDate

  try {
    if (date) {
      if (!format) {
        let tmp = JSON.parse(localStorage.getItem("User"))
        format = tmp.locale.formatDate
      }
      if (isValidDate(date)) {
        date = new Date(date).toISOString().split("T")[0]
      }
      format = format.replace("dd", "DD").replace("YYYY", "yyyy")
      return moment.utc(date).format(format);
    } else {
      return ""
    }
  } catch (e) {
    console.log(e)
    return ""
  }
}

function formatDateTime(datetime, formatDatetime) {
  let format = formatDatetime
  try {
    if (datetime) {
      if (!format) {
        let tmp = JSON.parse(localStorage.getItem("User"))
        format = tmp.locale.formatDateTime
      }
      if (isValidDate(datetime)) {
        datetime = new Date(datetime);
      }
      format = format.replace("dd", "DD").replace("YYYY", "yyyy")

      return moment.utc(datetime).local().format(format);
    } else {
      return ""
    }
  } catch (e) {
    console.log(e)
    return ""
  }
}

function formatDateAndTime(date, formatDate) {
  let format = formatDate;

  try {
    if (date) {
      // Recupera as informações de usuário do localStorage
      let tmp = JSON.parse(localStorage.getItem("User"));
      
      // Define o fuso horário de São Paulo (UTC-3)
      const timeZone = 'America/Sao_Paulo';  
      console.log("Fuso horário aplicado:", timeZone);

      // Se não houver um formato definido, usa o formato padrão do usuário
      if (!format) {
        format = tmp.locale.formatDateTime;
      }

      // Verifica se a data é válida usando a função isValidDateTime
      const validDate = isValidDateTime(date);
      console.log("Resultado de isValidDate:", validDate);

      if (validDate) {
        // Converte a data para o fuso horário de São Paulo (UTC-3)
        let dateTime = moment.tz(date, 'UTC');  // Assume que a data de entrada está em UTC
        console.log("Data original (UTC):", dateTime.format());

        // Agora subtrai 3 horas para ajustar para UTC-3
        dateTime = dateTime.tz(timeZone);  // Ajusta para o fuso horário de São Paulo
        console.log("Data ajustada para fuso horário de São Paulo (UTC-3):", dateTime.format());

        // Verifica se o formato já inclui horas
        const hasTime = format.includes("H") || format.includes("h");

        // Ajusta o formato: Adiciona " HH:mm:ss" se o formato não incluir horas
        const adjustedFormat = format.replace("dd", "DD").replace("YYYY", "yyyy") + (!hasTime ? " HH:mm:ss" : "");

        // Retorna a data ajustada e formatada corretamente
        return dateTime.format(adjustedFormat);  
      }
    }
    return "";
  } catch (e) {
    console.log("Erro ao formatar a data:", e);
    return "";
  }
}



function formatNumber(value: any) {
  const u = storageService.getUser();
  if (Number.isNaN(value) || value === null || value === '' || value === "NaN") {
    return 0;
  }
  value = value.toString();
  value = value.replaceAll(u.locale.decimalSeparator, "*");
  value = value.replaceAll(u.locale.thousandSeparator, "");
  value = value.replaceAll("*", ".");
  value = Number(value.replace(/[^0-9.-]+/g, "")).toFixed(2);
  return value;
}

function formatNumberIdioma(value: string) {
  const u = storageService.getUser();
  let valor = number_format((value), 2, u.locale.decimalSeparator, u.locale.thousandSeparator, '', '')
  //.toLocaleString(u.locale.code.trimEnd(), { minimumFractionDigits: 2 });
  return valor;
}

function number_format(string, decimals = 2, decimal = ',', thousands = '.', pre = 'R$ ', pos = ' Reais') {
  var decimalSeparatorIndex = string.toString().indexOf('.');  
  if (decimalSeparatorIndex < 0)string = string + ".00";
  var numbers = string.toString().match(/\d+/g).join([]);  
  numbers = numbers.padStart(decimals + 1, "0");
  var splitNumbers = numbers.split("").reverse();  
  var mask = '';
  splitNumbers.forEach(function (d, i) {
    if (i == decimals) { mask = decimal + mask; }
    if (i > (decimals + 1) && ((i - 2) % (decimals + 1)) == 0) { mask = thousands + mask; }
    mask = d + mask;
  });
  return pre + mask + pos;
}

function onlyNumber(text) {
  try {
    var numbers = text.toString().replace(/[^0-9]/g, '');

    if (Number.isNaN(numbers) || numbers === null || numbers === '') {
      numbers = 0
    }

    return parseInt(numbers);
  } catch (e) {
    return 0;
  }
}

function verifyIdiomDataTable() {
  let idiom = storageService.getIdiom();

  if (idiom) {
    return { ...dataTableConfig, language: dataTableConfigLaguages[idiom.replace('-', '')] };
  }
}


function toExportDateFormated(date) {
  const year = date.getFullYear().toString();
  const month = (
    date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1
  ).toString();
  const day =
    date.getDate() < 10
      ? "0" + date.getDate().toString()
      : date.getDate().toString();
  const hour =
    date.getHours() < 10
      ? "0" + date.getHours().toString()
      : date.getHours().toString();
  const min =
    date.getMinutes() < 10
      ? "0" + date.getMinutes().toString()
      : date.getMinutes().toString();

  return `${day}_${month}_${year}_${hour}_${min}`;
}

export default UtilService;
